import { AlertTriangle } from "lucide-react";
import { useNpa } from "../../lib/npa";
import { Field } from "./Field";

const Warn = ({ text, testId }) => text ? (
  <p data-testid={testId} className="mt-1.5 flex items-start gap-1.5 text-[13px] font-medium text-amber-700 sm:col-span-2"><AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />{text}</p>
) : null;

// Street / NPA / city block. `p` = key prefix in values ("" for intervention, "bill" for billing).
export const AddressBlock = ({ values, setValue, errors, p = "", group, warnZone = true }) => {
  const k = (n) => (p ? `${p}${n[0].toUpperCase()}${n.slice(1)}` : n);
  const id = (n) => (p ? `${p}-${n}` : n);
  const { warning, cities } = useNpa(values[k("npa")], (c) => setValue(k("city"), c));
  const on = (n) => (ev) => setValue(k(n), n === "npa" ? ev.target.value.replace(/\D/g, "").slice(0, 4) : ev.target.value);
  return (
    <>
      <Field id={id("street")} label="Rue et n° *" value={values[k("street")]} onChange={on("street")} error={errors[k("street")]} autoComplete={`${group}street-address`} className="sm:col-span-2" placeholder="Avenue de la Gare 12" />
      <Field id={id("npa")} label="NPA *" inputMode="numeric" maxLength={4} value={values[k("npa")]} onChange={on("npa")} error={errors[k("npa")]} autoComplete={`${group}postal-code`} placeholder="1003" />
      <Field id={id("city")} label="Localité *" value={values[k("city")]} onChange={on("city")} error={errors[k("city")]} autoComplete={`${group}address-level2`} list={cities.length > 1 ? `${id("city")}-list` : undefined} />
      {cities.length > 1 && <datalist id={`${id("city")}-list`}>{cities.map((c) => <option key={c} value={c} />)}</datalist>}
      {(warnZone || !warning.startsWith("Hors")) && <Warn text={warning} testId={`quote-${id("npa")}-warning`} />}
    </>
  );
};

export const QuoteAddress = ({ values, setValue, errors }) => (
  <fieldset className="grid grid-cols-1 gap-x-5 gap-y-4 sm:col-span-2 sm:grid-cols-2" data-testid="quote-address-section">
    <legend className="mb-3 font-display text-base font-bold text-cs-navy">Adresse de l'intervention</legend>
    <AddressBlock values={values} setValue={setValue} errors={errors} group="" />
    <Field id="access" label="Étage / accès / remarques" value={values.access} onChange={(e) => setValue("access", e.target.value)} className="sm:col-span-2" placeholder="Ex. 3e étage, ascenseur, code 1234, parking devant l'immeuble" maxLength={300} />
    <label className="flex cursor-pointer items-center gap-2.5 text-sm font-semibold text-cs-navy sm:col-span-2">
      <input type="checkbox" className="h-5 w-5 accent-[#12303f]" checked={values.billDiff} onChange={(e) => setValue("billDiff", e.target.checked)} data-testid="quote-billing-diff-checkbox" />
      L'adresse de facturation est différente
    </label>
    {values.billDiff && (
      <div className="grid grid-cols-1 gap-x-5 gap-y-4 rounded-xl bg-cs-grey p-4 sm:col-span-2 sm:grid-cols-2" data-testid="quote-billing-section">
        <Field id="bill-name" label="Nom / entreprise de facturation" value={values.billName} onChange={(e) => setValue("billName", e.target.value)} autoComplete="billing organization" className="sm:col-span-2" />
        <AddressBlock values={values} setValue={setValue} errors={errors} p="bill" group="billing " warnZone={false} />
      </div>
    )}
  </fieldset>
);
